import { Injectable } from '@angular/core';
import { map, tap, first, filter } from 'rxjs/operators';
import { Router, ActivationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { MemberNewsStore } from '../../../common-page-components/stores/entities-store/member-news-store';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MembersRouterInterceptorService {

  constructor(protected http:HttpClient){

  }

  /**
   * The members news store to be loaded depen
   *
   * @memberof MembersRouterInterceptorService
   */
  memberNewsStore = new MemberNewsStore(this.http);

  /**
   * Subject for check if the url data is continental or not.
   *
   * @memberof MembersRouterInterceptorService
   */
  isContinental = new BehaviorSubject(undefined);

  /**
   * Async method for check if the requested data is continental.
   *
   * @readonly
   * @memberof MembersRouterInterceptorService
   */
  get isContinentalMember(){
    return this.isContinental.asObservable().pipe(filter(a=> a !== undefined));
  }

}
